// extracted by mini-css-extract-plugin
export default {"bolo__containerSlides":"Carousel_bolo__containerSlides__co2-o","bullets":"Carousel_bullets__pLZUW","bolo__containerDots":"Carousel_bolo__containerDots__UqSDx"};